import { TEXT_SIZE } from 'platform-components/constants';

import { PROBLEMS_STUB_SIZE } from './typings';

export const problemsStubTextSizeMap = {
    [PROBLEMS_STUB_SIZE.L]: TEXT_SIZE.L,
    [PROBLEMS_STUB_SIZE.XL]: TEXT_SIZE.XL,
};
